module.exports = __webpack_public_path__ + "static/img/title-icon.6826e2c5.png";